import { Domain } from '../entities/models/domain.model';
import { DomainResponse } from '../entities/models/domain-response.model';
import { transformSnakeToCamel } from './transformers';

export function normalizeDomainsResponse(domainsList: DomainResponse[]): {
  entities: {
    domains: Domain[];
  };
} {
  if (!domainsList || !Array.isArray(domainsList)) {
    return {
      entities: {
        domains: [],
      },
    };
  }

  const normalizedDomains: Domain[] = domainsList.map((domainResponse) => {
    return transformSnakeToCamel(domainResponse) as Domain;
  });

  return {
    entities: {
      domains: normalizedDomains,
    },
  };
}

